// extracted by mini-css-extract-plugin
export default {"Events":"EventsDark_Events__9m74W"};